import { Route, Routes } from 'react-router-dom';
import * as React from 'react';
import LoginDashboard from 'dashboard/pages/LoginDashboard';
import Sidebar from 'dashboard/containers/Sidebar';
import VideoGrapherList from 'dashboard/pages/VideoGrapherList';
import VideoGrapherDetails from 'dashboard/pages/VideoGrapherDetails';
import PostList from 'dashboard/pages/PostList';
import PostDetailsDashboard from 'dashboard/pages/PostDetailsDashboard';
import WithdrawRequestList from 'dashboard/pages/WithdrawRequestList';
import NotificationPage from 'dashboard/pages/NotificationPage';
import InvoiceList from 'dashboard/pages/InvoiceList';
import InvoiceDetails from 'dashboard/pages/InvoiceDetails';
import NotFound from 'client/pages/NotFound';
import { useDashboardRouter } from './useDashboardRouter';
import LoggedOutRoute from './LoggedOutRoute';
import PrivateRoute from './PrivateRoute';
import TourCategoriesPage from '../../pages/TourCategoriesPage/TourCategoriesPage';
import CategoryTourDetails from '../../pages/CategoryTourDetails';
import ToursPage from '../../pages/ToursPage/ToursPage';
import TourDetails from '../../pages/TourDetails';
import 'dashboard/index.scss';

const DashboardRoot = () => {
  const { isLoggedIn } = useDashboardRouter();

  return (
    <div className="dashboard-layout" style={{ display: 'flex', minHeight: '100vh' }}>
      {isLoggedIn && <Sidebar />}
      <div className="dashboard-content" style={{ flex: 1, overflowY: 'auto' }}>
        <div className="container-fluid">
          <Routes>
            <Route path="/" element={<LoggedOutRoute component={LoginDashboard} />} />
            <Route path="/login" element={<LoggedOutRoute component={LoginDashboard} />} />
            <Route path="/videographers" element={<PrivateRoute component={VideoGrapherList} />} />
            <Route path="/videographer/:id" element={<PrivateRoute component={VideoGrapherDetails} />} />
            <Route path="/videos" element={<PrivateRoute component={PostList} />} />
            <Route path="/video/:id" element={<PrivateRoute component={PostDetailsDashboard} />} />
            <Route path="/withdraw" element={<PrivateRoute component={WithdrawRequestList} />} />
            <Route path="/notification" element={<PrivateRoute component={NotificationPage} />} />
            <Route path="/categories-tour" element={<PrivateRoute component={TourCategoriesPage} />} />
            <Route path="/category-tour/:id" element={<PrivateRoute component={CategoryTourDetails} />} />
            <Route path="/tours" element={<PrivateRoute component={ToursPage} />} />
            <Route path="/tour/:id" element={<PrivateRoute component={TourDetails} />} />
            <Route path="/invoices" element={<PrivateRoute component={InvoiceList} />} />
            <Route path="/invoices/:userId" element={<PrivateRoute component={InvoiceDetails} />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default DashboardRoot;
